export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5125.620b922d.jpg";